import { ExtraSortStatus, ModuleConfig, ModuleName } from '../types/module-config';
import VitasoyLotteryModule from '@/views/home/vitasoy-lottery-module/index.vue';
import { VITASOY_LOTTERY_DIALOG } from './dialog-manager-config';
export interface SpModuleConfig extends ModuleConfig {
  spId: string, // 商户id
}

/** 商户模块屏蔽配置 */
export interface SpHiddenModuleConfig {
  spId: string;
  moduleName: ModuleName;
}

/**
 * 商户模块屏蔽列表
 * 用于在特定商户页面隐藏指定模块
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const spHiddenModuleConfig: SpHiddenModuleConfig[] = [
  // 维他奶 2025 活动：屏蔽 WePoints 模块，改为电子现金券奖励
  { spId: 'Vitasoy', moduleName: ModuleName.wePointsModule },
  // 维他奶 2026 活动：屏蔽投放中台广告 banner
  { spId: 'Vitasoy', moduleName: ModuleName.bannerModule },
];

/** 商户专属模块
 * 针对特定spId展示特定组件
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const spModuleConfig: Array<SpModuleConfig> = [
  {
    /** 维他奶商户-cdkey抽奖模块 */
    spId: 'Vitasoy',
    moduleName: ModuleName.VitasoyLotteryModule,
    component: VitasoyLotteryModule,
    extraSort: ExtraSortStatus.common,
    sort: 100,
  },

];

/** 弹窗管理器-商户专属弹窗 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const spDialogList = [
  { name: VITASOY_LOTTERY_DIALOG, order: 10, spId: 'Vitasoy', moduleName: ModuleName.VitasoyLotteryModule }, // 优先级最高
];
